<template>
    <router-view/>
</template>


<script setup>
import { FONTS, COLORS } from '@/styles/brand'
</script>

<style>
body {
    margin: 0;
    padding: 0;
    font-family: v-bind('FONTS.GOOGLE');
    background-color: #1f1f4f;
}

* {
    font-family: v-bind('FONTS.GOOGLE');
}
</style>
